// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"S_-z","disabled":"T_-z","label":"U_-z"};